export const GET_LANDINGPAGE_BY_ID_METHOD = (id, preview: boolean) => `
query {
  landingpage(id: "${id}", preview: ${preview}) {
  sys {
        id
      }
      linkedFrom {
        pageCollection(limit: 1) {
          items {
            sys {
              id
            }
          }
        }
      }
      heading
      preamble
      ivMainImage
      topImageText
      heroContentAreaCollection {
        items {
          __typename
          ...on ImageBlock {sys{id}}
          ...on Link {sys{id}}
        }
      }
      mainAreaCollection{
        items{
            __typename
          ...on RichTextBlock {sys{id}}
          ...on AccordionBlock{sys{id}}
          ...on FileBlock{sys{id}}
          ...on InformationBlock{sys{id}}
          ...on InsurancePickerBlock{sys{id}}
          ...on TeaserBlock{sys{id}}
          ...on Link{sys{id}}
          ...on Sectionblock{sys{id}}
          ...on Videoblock{sys{id}}
          ...on TableBlock {sys{id}}
          ...on Page{sys{id}}
          ...on PersonalizationBlock{sys{id}}
          ...on ContactBlock{sys{id}}
          ...on QuoteBlock{sys{id}}
          ...on ShortCutsBlock{sys{id}}
          ...on ListBlock {sys {id}}
          ...on FaqListBlock {sys {id}}
          ...on ImageBlock {sys {id}}
          ...on FormBlock {sys {id}}
          ...on FileListBlock {sys{id}}
          ...on PaymentDaysBlock {sys{id}}
          ... on BannerBlock {
            sys {
              id
            }
          }
          ... on ContactUsBlock {
            sys {
              id
            }
          }
          ... on LinkTeaserBlock {sys {id}}
          }
      }
      relatedContentHeading
      relatedContentSmallImages
      relatedContentCollection {
        items {
          __typename
          ...on TeaserBlock{sys{id}}
          ...on Page{sys{id}}
        }
      }
  }
}
`;
